<template>
    <button
        :disabled="disabled"
    >
        <slot />
        <transition-group
                name="fade"
                mode="out-in"
        >
            <i
                v-if="loading"
                key="spinner"
                class="fas fa-spinner fa-spin"
            />
            <i
                v-if="!loading && hasArrow"
                key="arrow"
                class="far fa-long-arrow-right"
            />
        </transition-group>
    </button>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: [Boolean, String],
            default: false,
        },
        hasArrow: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
